import { api, API, TOKEN_KEY } from "./api";

export const canRecord = () =>
  typeof window !== "undefined" && !!(navigator.mediaDevices?.getUserMedia && window.MediaRecorder);

function pickMime() {
  const c = ["audio/webm;codecs=opus", "audio/webm", "audio/mp4", "audio/aac", "audio/ogg"];
  return c.find((m) => window.MediaRecorder.isTypeSupported?.(m)) || "";
}

export async function startRecording() {
  const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  const mime = pickMime();
  const rec = new MediaRecorder(stream, mime ? { mimeType: mime } : undefined);
  const chunks = [];
  rec.ondataavailable = (e) => e.data && e.data.size && chunks.push(e.data);
  rec.start();
  return {
    stop: () =>
      new Promise((resolve) => {
        rec.onstop = () => {
          stream.getTracks().forEach((t) => t.stop());
          resolve(new Blob(chunks, { type: rec.mimeType || mime || "audio/webm" }));
        };
        rec.stop();
      }),
  };
}

export async function transcribe(blob, language) {
  const ext = blob.type.includes("mp4") || blob.type.includes("aac") ? "mp4" : blob.type.includes("ogg") ? "ogg" : "webm";
  const fd = new FormData();
  fd.append("audio", blob, `speech.${ext}`);
  fd.append("language", language);
  const { data } = await api.post("/voice/transcribe", fd);
  return data;
}

function parseEvents(chunk, state, onDelta) {
  for (const part of chunk.split("\n\n")) {
    const line = part.replace(/^data: /, "").trim();
    if (!line) continue;
    const ev = JSON.parse(line);
    if (ev.error) throw new Error(ev.error);
    if (ev.delta) {
      state.text += ev.delta;
      onDelta(state.text);
    }
    if (ev.done) state.meta = ev;
  }
}

export async function streamChat(body, onDelta) {
  const res = await fetch(`${API}/voice/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}` },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error("Assistant request failed");
  const state = { text: "", meta: {} };
  if (!res.body || !res.body.getReader) {
    parseEvents(await res.text(), state, onDelta);
    return state;
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const idx = buf.lastIndexOf("\n\n");
    if (idx >= 0) {
      parseEvents(buf.slice(0, idx), state, onDelta);
      buf = buf.slice(idx + 2);
    }
  }
  if (buf.trim()) parseEvents(buf, state, onDelta);
  return state;
}

export async function ttsUrl(text, language) {
  const r = await api.post("/voice/tts", { text, language }, { responseType: "blob" });
  return URL.createObjectURL(r.data);
}
